export default function mobileMenuHandler() {

    const hamburgerFunctionality = () => {
        const hamburger = $('.elementor-menu-toggle');

        hamburger.click(function() {
            hamburger.toggleClass('elementor-active');
        });
    };

    hamburgerFunctionality();
}


// WEBPACK FOOTER //
// ./scriptPartials/mobileMenuHandler.js